export default {
      id: "meat-usage",
      viewBox: "0 0 40 31",
      url: __webpack_public_path__ + "img/icons.svg#meat",
      toString: function () {
        return this.url;
      }
    }